import { render, staticRenderFns } from "./MyIntroduce3.vue?vue&type=template&id=34d7584a&scoped=true"
import script from "./MyIntroduce3.vue?vue&type=script&lang=js"
export * from "./MyIntroduce3.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce3.vue?vue&type=style&index=0&id=34d7584a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7584a",
  null
  
)

export default component.exports